<template>
  <div class="property-banner">
    <img :src="propertyBanner" alt="" />
    <div class="absolute">
      <div class="title">智慧物业</div>
      <div class="text">
        自主研发数字化创新方案和产品，为物业企业提供物业管理信息化、数字化整体解决方案。赋能物业企业开启智慧物业之旅，打通信息孤岛、提升管理效能，实现物业企业业务规模和商业模式的升级。
      </div>
      <div class="experience" @click="experienceClick">立即体验</div>
    </div>
  </div>
  <Experience
    v-if="experienceShow"
    :experienceShow="experienceShow"
    @experienceClick="experienceClick"
  ></Experience>
</template>

<script>
import { reactive } from "vue";

import Experience from "../../../../components/pc/components/Experience.vue";

import propertyBanner from "../../../../assets/programme/propertyBanner.png";

export default {
  setup() {
    return reactive({
      propertyBanner: propertyBanner,
      experienceShow: false,
    });
  },
  components: {
    Experience,
  },
  methods: {
    experienceClick() {
      this.experienceShow = !this.experienceShow;
    },
  },
};
</script>

<style scoped>
.property-banner {
  position: relative;
}
@media screen and (max-width: 1180px) {
  .property-banner {
    min-width: 1180px;
  }
}
.property-banner img {
  width: 100%;
  height: 368px;
}
.absolute {
  position: absolute;
  top: 50%;
  left: 36%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 40px;
}
.absolute .title {
  font-size: 30px;
  color: #248efb;
}
.absolute .text {
  width: 540px;
  font-size: 14px;
  margin-top: 20px;
  color: #248efb;
}
.absolute .experience {
  margin-top: 20px;
  font-size: 16px;
  color: #248efb;
  width: 108px;
  height: 36px;
  line-height: 36px;
  border: 1px solid #248efb;
  border-radius: 6px 6px 6px 6px;
  text-align: center;
  cursor: pointer;
}
</style>
